var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"text-right"},[_c('p',[_c('span',[_vm._v("© "+_vm._s(_vm.currentYear)+" C2B Software")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }